import { Calendar, WhatsappLogo, Info } from "@phosphor-icons/react";
import { DATA_FRESHNESS, freshnessLabel, freshnessTone } from "../../lib/dataFreshness";

export function FreshnessBadge({ calc }) {
  const yyyymm = DATA_FRESHNESS[calc];
  if (!yyyymm) return null;
  const tone = freshnessTone(yyyymm);
  const cls = tone === "green" ? "bg-green-500/10 text-green-700 border-green-500/30"
            : tone === "amber" ? "bg-amber-500/10 text-amber-700 border-amber-500/30"
            : tone === "red"   ? "bg-red-500/10 text-red-700 border-red-500/30"
            : "bg-muted/30 text-muted-foreground border hairline";
  return (
    <span className={`inline-flex items-center gap-1 text-[11px] px-2 py-0.5 rounded-full border ${cls}`}
      data-testid={`freshness-${calc}`}>
      <Calendar size={11} weight="duotone" />
      Rates updated: {freshnessLabel(yyyymm)}
    </span>
  );
}

export function CalcDisclaimer({ calc }) {
  const date = freshnessLabel(DATA_FRESHNESS[calc] || "");
  return (
    <div className="text-[10px] text-muted-foreground mt-4 italic" data-testid={`calc-disclaimer-${calc}`}>
      Results are indicative estimates based on inputs and rates as of {date}.
      Tax computations are illustrative and do not constitute professional tax advice.
      Consult a CA / financial advisor before investment or tax decisions. Estima is
      not liable for decisions made based on calculator outputs.
    </div>
  );
}

export function WhatsAppShare({ calc, message, label = "Share results" }) {
  if (!message) return null;
  const url = `https://wa.me/?text=${encodeURIComponent(
    message + `\n\nCalculate yours free: estima.co.in?utm_source=whatsapp&utm_medium=share&utm_campaign=${calc}`
  )}`;
  return (
    <button
      onClick={() => window.open(url, "_blank")}
      className="inline-flex items-center gap-1.5 px-3 py-1.5 text-xs font-medium rounded text-white hover:opacity-90"
      style={{ background: "#25D366" }}
      data-testid={`whatsapp-share-${calc}`}>
      <WhatsappLogo size={14} weight="fill" />
      {label}
    </button>
  );
}

export function CalcHeader({ calc, title, subtitle, children }) {
  return (
    <div className="mb-4 flex items-baseline justify-between gap-3 flex-wrap">
      <div>
        <div className="eyebrow inline-flex items-center gap-2">{title}<FreshnessBadge calc={calc} /></div>
        {subtitle && <div className="text-xs text-muted-foreground mt-1 max-w-2xl">{subtitle}</div>}
      </div>
      {children}
    </div>
  );
}

export function NumField({ label, value, onChange, step, suffix, tooltip, testid, min, max, warn }) {
  return (
    <label className="text-xs space-y-1 block">
      <div className="flex items-center justify-between gap-2">
        <span className="text-muted-foreground inline-flex items-center gap-1">
          {label}
          {tooltip && <span title={tooltip}><Info size={11} weight="duotone" /></span>}
        </span>
        {suffix && <span className="text-[10px] text-muted-foreground">{suffix}</span>}
      </div>
      <input type="number" value={value ?? ""} step={step || 1}
        onChange={(e) => onChange(e.target.value === "" ? "" : Number(e.target.value))}
        className="w-full bg-background border hairline px-2 py-1.5 text-xs"
        min={min} max={max}
        data-testid={testid} />
      {warn && <div className="text-[10px] text-amber-600">{warn}</div>}
    </label>
  );
}
